/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing variable-name align */

import {ElementRef}         from '@angular/core';

import {Dialog}              from './dialog';
import {Logger}              from '@/util/logger';
import {IValidatorCallBack}  from './i.validator.call.back';
import {IOkCallBack}         from './i.ok.call.back';
import {
  BlobType,
  Blob
}                            from '@/models/blob';
import { User }              from '@/models/user';

import * as $                from 'jquery';
import 'jquery-ui-dist/jquery-ui';

import 'jquery.fancytree/dist/modules/jquery.fancytree.dnd5';
import 'jquery.fancytree/dist/modules/jquery.fancytree.edit';
import 'jquery.fancytree/dist/modules/jquery.fancytree.glyph';
import 'jquery.fancytree/dist/modules/jquery.fancytree.wide';
import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';
import 'jquery.fancytree/dist/modules/jquery.fancytree.multi';

const fancytree = require('jquery.fancytree');

import 'jquery-contextmenu';

import FancytreeNode = Fancytree.FancytreeNode;
import {first} from 'rxjs/operators';
import {ServiceManager} from "@/services/service.manager";

/**
 *
 * @class AddBlobDialog
 *
 * @brief dialog for adding blobs, but by copying existing blobs already uploaded.   Basically
 * we use FancyTree to browse the blob manager files and they can cherry pick from there.
 *
 * FancyTree docs:
 *
 * @link https://wwwendt.de/tech/fancytree/doc/jsdoc/index.html
 * @link https://github.com/mar10/fancytree/wiki/TutorialLoadData
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class AddBlobDialog extends Dialog {

  /** the type of blob import */
  private type: BlobType = BlobType.Scenario;

  /** the kinds of blob import allowed */
  private allowed: BlobType[] = [BlobType.Scenario, BlobType.Plant, BlobType.Traffic];

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  private user: User;

  private services: ServiceManager;

  /** the fancy tree object */
  private _tree                                = null;

  /** standard constructor, allow for partial alert to be given */
  constructor(
       host: ElementRef,
   services: ServiceManager
  ) {

    super(host);

    this.services = services;

    this.title   = 'Add (clone) Blob(s)';
    this.icon    = '<i class="fas fa-plus"></i>';

    Logger.debug('[AddBlobDialog] setting up...');
  }

  /** full reset on the tree */
  private clearTree() {

    if (this._tree) {

      $('#add-blob-dialog-fancytree').fancytree('destroy');

      this._tree = null;
    }

  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator = validator ? validator : null;
    this.success   = success   ? success   : null;
    this.user      = this.services.projects.user();
    this.type      = BlobType.Scenario;

    this.disable();

    const    homePath: string[] = [
      '/',
      '/users',
      '/users/' + this.user.username
    ];

    const projectPath: string[] = [
      '/',
      '/users',
      '/users/' + this.user.username,
      '/users/' + this.user.username + '/projects'
    ];

    const quintiqPath: string[] = [
      '/incoming',
      '/incoming/quintiq'
    ];

    Logger.debug('[AddBlobDialog] opening...');

    const body = $(this.host).find('.modal-body');

    $(body).parent().css('min-height', '400px');

    const html = `
<div class="add-blob-dialog-quickaction">
<label id="add-blob-home-click" class="gui-button" title="Jump to home"><i class="fas fa-home" ></i></label>
<label id="add-blob-projects-click" class="gui-button" title="Jump to Projects"><i class="fas fa-project-diagram" ></i></label>
<label id="add-blob-quintiq-click" class="gui-button" title="Ab-Ovo/Qunitiq Incoming">Q</label>
<label id="add-blob-hidden-click" class="gui-button" title="Show hidden files"><i class="far fa-eye-slash" ></i></label>

<div
  class="control gui-radio-toolbar"
  style="width: calc(100% - 136px); display: inline-block; margin-left: 8px;">

  <input class="add-blob-clone-kind" id="add-clone-scenario-blob" type="radio" name="type"  value="scenario" checked>
  <label for="add-clone-scenario-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-scenario-20.png" style="margin-right: 8px;">Scenario
  </label>

  <input class="add-blob-clone-kind" id="add-clone-plant-blob" type="radio" name="type"  value="plant">
  <label for="add-clone-plant-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-plant-20.png" style="margin-right: 8px;">Plant
  </label>

  <input class="add-blob-clone-kind"  id="add-clone-traffic-blob" type="radio" name="type"  value="traffic">
  <label for="add-clone-traffic-blob" class="radio">
    <img src="assets/images/blob-icons/blob-traffic-20.png" style="margin-right: 8px;">Traffic
  </label>

</div>

</div>

<div class="add-blob-dialog-path" style="margin-top: 12px;">
<input
  class="gui-input add-blob-path-input"
  style="width: 100%;"
  type="text"
  title="Enter a path to focus on"
  placeholder="File or Folder Path">
</div>

<div
  class="add-blob-dialog-fancytree"
  id="add-blob-dialog-fancytree"
  style="margin-top: 12px; overflow: auto; display: block; height: calc(100% - 96px); max-height: 400px;">

</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      /* set a fresh directory tree */

      this.clearTree();

      // noinspection JSJQueryEfficiency
      $('#add-blob-dialog-fancytree').fancytree({

        extensions: ['dnd5', 'glyph', 'wide', 'filter', 'multi'],

        selectMode: 2,
        generateIds: true,
        idPrefix: '',

        source:    [
          {
            title: '/',
            key: '/',
            folder: true,
            expanded: true,
            lazy: true,
            children: null,
            icon: 'assets/images/blob-icons/blob-folder-20.png'
          }
        ],

        lazyLoad: (event, data) => {

          const node: FancytreeNode = data.node;

          const dfd   = $.Deferred();
          data.result = dfd.promise();

          this.ls(node.key, dfd);
        },

        select: () => {

          this.error('');
          this.disable();

          const selection: FancytreeNode[] = this._tree.getSelectedNodes();

          if (selection.filter(x => !x.folder).length > 0) {

            this.enable();
          }

          if (selection.length !== 1) {

            /* for multi-select we don't update the path field */

            return ;
          }

          const path = selection[0].key;

          $(this.host).find('.add-blob-path-input').val(path);

        },

        autoActivate: true,

        activeVisible: true,

        autoScroll: true,

        glyph: {
          preset: 'awesome5',
          map: {}
        },


      });

      // noinspection JSJQueryEfficiency
      this._tree = $('#add-blob-dialog-fancytree').fancytree('getTree');

      this.expandPathway(homePath);

    }, 50);

    $('#add-blob-home-click').on('click', () => {

      this.expandPathway(homePath);
    });

    $('#add-blob-projects-click').on('click', () => {

      this.expandPathway(projectPath);
    });

    $('#add-blob-quintiq-click').on('click', () => {

      this.tryPathway(quintiqPath);
    });

    $(this.host).find('.add-blob-path-input').on('input', (e) => {

      /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

      if (this.typingTimer) {

        clearTimeout(this.typingTimer);
      }

      this.typingTimer = setTimeout(() => {

        const path: string = $(e.currentTarget).val() as string;

        this.tryPath(path);

      }, 400);

    });

    $(this.host).find('.add-blob-path-input').on('keypress', (e) => {

      if (this.typingTimer) {

        clearTimeout(this.typingTimer);
      }

      this.typingTimer = setTimeout(() => {

        const path: string = ($(e.currentTarget).val() as string).trim();

        this.tryPath(path);

      }, 400);

    });

    $('input.add-blob-clone-kind[type=radio][name=type]').on('input', (e) => {

      this.type = Blob.typeofString($(e.currentTarget).val() as string);

      this.validate();
    });

    /* disable the Ok button...until we have valid input */

    this.validate();
  }

  /** convenience to upgrade a string path to its pathway of keys */
  private tryPath(dir: string) {

    const path = dir.replace(new RegExp('[/]+$'), '');

    this.error('');

    const pathWay: string[] = [];
    const pieces:  string[] = path.split('/');
    const n:         number = pieces.length;

    for (let i = 0; i < n; i++) {

      /* build the next parent */

      let item = '';

      for (let j = 1; j <= i; j++) {

        item = item + '/' + pieces[j];

      }

      if (item === '') {
        continue;
      }

      pathWay.push(item);
    }

    this.expandPathway(pathWay);
  }

  /** before expanding a path, check if it even exists, and if not, error out */
  private tryPathway(segs: string[]) {

    const key: string = segs[segs.length - 1];

    this.services.blobber.fileordir(key)
      .pipe(first())
      .subscribe(
        item => {

          if (!item) {

            this.error(`Path does not exist (${key}).`);

            return ;
          }

          Logger.debug("[AddBlobDialog] expanding path: ", item);

          this.expandPathway(segs);
        },
      () => {

          this.error(`Path does not exist (${key}).`);
      });

  }

  /** expand the tree to a given point */
  private expandPathway(parents: string[]) {

    this._tree.getSelectedNodes().forEach(item => item.setSelected(false));

    let key: string        = '';
    let   n: FancytreeNode = null;
    let segs: string[]     = [];

    segs = segs.concat(parents);

    while (true) {

      if (segs.length === 0) {

        break;
      }

      key = segs.shift();
      n   = this._tree.getNodeByKey(key);

      if (n === null) {

        this.error(`Path does not exist (${key}).`);

        return;
      }

      if (n.children === null) {

        break;
      }
    }

    if (!n) {

      return ;
    }

    const pending = $.Deferred();

    pending.then((results) => {

      /* add the children */

      n.addChildren(results);
      n.setExpanded(true);
      n.setSelected(true);
      n.setActive(true);

      /* keep going */

      if (segs.length) {

        this.expandPathway(segs);
      }
    },
      () => {

    });


   /* n.getParentList(true, true).forEach(x => x.toggleExpanded()); */

    n.setSelected(true);
    n.setActive(true);

    if (n.children === null) {

      this.ls(key, pending);
    }

  }

  /** list a directory in format suitable for FancyTree */
  private ls(path: string, dfd) {

    this.services.blobber.list(true, path, '/')
      .pipe(first())
      .subscribe(
        (listing: any) => {

          const results = [];

          listing.result.forEach((item) => {

            const name: string = item.name;
            const dir: string = path.replace(new RegExp('[/]+$'), '');

            if (item.file === false) {

              results.push({
                title: name,
                key: dir + '/' + name,
                folder: true,
                expanded: false,
                lazy: true,
                children: null,
                icon: 'assets/images/blob-icons/blob-folder-20.png'
              });

            } else {

              let   icon: string   = 'assets/images/blob-icons/blob-file-20.png';
              const type: BlobType = Blob.typeofString(item.type);

              if (type !== BlobType.None) {

                icon = 'assets/images/blob-icons/' + Blob.iconOfType(type);
              }

              results.push({
                title: name,
                key: item.key,
                folder: false,
                expanded: true,
                icon
              });
            }

          });

          dfd.resolve(results);
        },
        error => {

          Logger.error('[AddBlobDialog] could not list folder: ', error);

          dfd.reject(error);
        });

    return [];
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    this.error('');

    /* assume its bad */

    this.disable();

    if (this._tree === null) {

      return ;
    }

    const selection: FancytreeNode[] = this._tree.getSelectedNodes();

    if (!this.validator) {

      if (this.allowed.find(x => x === this.type)) {

        this.error('Unknown kind of input: ' + Blob.stringOfType(this.type));

        return ;
      }

      if (selection.filter(x => !x.folder).length === 0) {

        this.error('No files selected.');
      }

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so its ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        const keys: string[] = this._tree.getSelectedNodes().filter(x => !x.folder).map(x => x.key);

        this.validator({keys, type: this.type}, resolve, reject);

      }).then((data: any) => {

        const keys: string[] = data.keys as string[];
        this.type            = data.type  as BlobType;

        this.enable();

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        this.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[AddBlobDialog] closing...');

    this.clearTree();
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[AddBlobDialog] accepted: ');

    if (this.success) {

      /* inform the client */

      const keys: string[] = this._tree.getSelectedNodes().filter(x => !x.folder).map(x => x.key);

      this.success( {type: this.type, keys} );
    }

    this.clearTree();
  }
}


